export const LOGOS = {
    "EUREX": "icons/Logo_Eurex.svg",
    "XETRA": "icons/Logo_Xetra.svg",
    "360T": "icons/360T.png",
    "Clearstream": "icons/Logo_Clearstream.png",
    "IIGF": "icons/Logo_IIGF.png",
    "KAIKO": "icons/Logo_Kaiko.png",
    "XFRA": "icons/Logo_Boerse_Frankfurt.png",
    "CANARI.DEV": "icons/Logo_canari_small.png",
    "ISS": "icons/Logo_ISS.png",
    "BMLL": "icons/Logo_BMLL.png",
    "KNEIP": "icons/Logo_Kneip.png",
    "EEX": "icons/Logo_EEX.png",
    "TRADEGATE": "icons/Logo_Tradegate.png"
};
